class MyLoansMobileFiltersController {
  constructor(EventEmitter) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.open = false;
  }

  $onInit() {
    this.statesToFilter = this.objectStatesFilter.statesToFilter;
    this.loansStates = this.objectStatesFilter.loansStates;
    this.selectedFilterStatus = '';
    this.labelTextDefault = '';
  }

  toggle() {
    this.open = !this.open;
  }

  getArrowClass() {
    return {
      icon: true,
      'icon-arrow-select-down': !this.open,
      'icon-arrow-select-up': this.open,
    };
  }

  getSelectClass() {
    return {
      blue: this.open,
    };
  }

  clearFilters() {
    this.changeFilterByStatus('', '');
  }

  changeFilterByStatus(state, valueText) {
    this.selectedFilterStatus = this.selectedFilterStatus === state ? '' : state;
    this.filterByStatus(this.EventEmitter({ status: this.selectedFilterStatus, filterActive: true }));
    this.labelTextDefault = this.labelTextDefault === valueText ? '' : valueText;
    if (state) {
      this.toggle();
    }
  }
}

export default MyLoansMobileFiltersController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/myLoansMobileFilters/myLoansMobileFilters.controller.js